import * as React from 'react';
import { connect } from 'react-redux';

// Router
import { withRouter } from 'react-router-dom';

// Actions
import {
  loadSupportFaq,
  loadSupportFaqSuccess,
  loadUnauthenticatedSupportFaq,
  loadUnauthenticatedSupportFaqSuccess,
  loadGeoIPCountrySuccess,
  loadGeoIPCountry,
  fetchCountry,
  fetchCountrySuccess,
  loadProductUpdate,
  handleDownloadModal,
  handleDownloadUrl
} from 'src/Actions/Support/supportActions';

// Component
import Support from './Support';
import { getNativeAppConfig } from 'src/Actions/collab/collabActions';

export const SupportWithProps = (props) => <Support {...props} />;

export const mapStateToProps = ({ support, subscription, collab, generic }) => ({
  support,
  subscription,
  collab,
  generic
});

export const mapDispatchToProps = (dispatch) => ({
  loadSupportFaq: () => dispatch(loadSupportFaq()),
  loadUnauthenticatedSupportFaq: () => dispatch(loadUnauthenticatedSupportFaq()),
  loadSupportFaqSuccess: (list) => dispatch(loadSupportFaqSuccess(list)),
  loadUnauthenticatedSupportFaqSuccess: (list) => dispatch(loadUnauthenticatedSupportFaqSuccess(list)),
  loadGeoIPCountry: () => dispatch(loadGeoIPCountry()),
  loadGeoIPCountrySuccess: (list) => dispatch(loadGeoIPCountrySuccess(list)),
  fetchCountry: () => dispatch(fetchCountry()),
  fetchCountrySuccess: (list) => dispatch(fetchCountrySuccess(list)),
  loadProductUpdate: (language) => dispatch(loadProductUpdate(language)),
  getNativeAppConfig: () => dispatch(getNativeAppConfig()),
  handleDownloadModal: (stage) => dispatch(handleDownloadModal(stage)),
  handleDownloadUrl: (url) => dispatch(handleDownloadUrl(url))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SupportWithProps));
